<template>
  <div class="flex h-full">
    <div class="flex border-r w-[460px] max-h-full overflow-y-scroll">
      <Aside/>
    </div>
    <div class="flex-1 grid_wrap">
      <div style="grid-column: 1 / span 2;">
        <Nav/>
      </div>
      <div class="overflow-scroll">
        <Editor/>
      </div>
      <Map/>
    </div>
    <div
      v-show="is_loading"
      class="mask"
    >
      <div class="center">
        <div class="w-20 h-20 loader_rotate"></div>
      </div>
    </div>
    <div
      v-show="is_saving"
      class="mask"
    >
      <div class="center">
        <div class="w-20 h-20 loader_rotate"></div>
        <p class="text-white text-xl ml-4">Saving...</p>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/main/Nav'
import Editor from '@/components/main/Editor'
import Aside from '@/components/main/Aside'
import Map from '@/components/main/Map'

import { MainVState } from '@/state/main'

export default {
  name: 'AQFE',

  components: {
    Nav,
    Aside,
    Editor,
    Map
  },

  created() {
    // 為了方便測試，加上 dtg 參數
    const dtg = this.$route.query.dtg;

    // 不在 prod 的話，或在允許 dtg 的環境（如 staging），以 dtg 參數設定系統時間
    if (dtg && (process.env.NODE_ENV !== 'production' || process.env.VUE_APP_ALLOW_DTG === 'true')) {
      try {
        MainVState.set_system_datetime_by_dtg(dtg);
      } catch (e) {
        console.error('Invalid dtg parameter:', dtg);
        return;
      }
    } else{
      MainVState.init();
    }
  },

  computed: {
    is_loading() {
      return MainVState.is_loading
    },
    is_saving() {
      return MainVState.is_saving
    }
  }
}
</script>

<style lang="scss" scoped>
.grid_wrap {
  @apply grid h-full;
  grid-template-columns: min-content auto;
  grid-template-rows: min-content auto;
}
</style>
